<template>
  <div class="employee-card">
    <img :src="person.image" class="image-card" alt="Personal Image" />

    <div class="content-card">
      <div class="head-card">
        <div class="titles-card clear">
          <h2>{{ person.name }}</h2>
          <p v-if="person.position">{{ person.position }}</p>
          <p v-if="person.title">{{ person.title }}</p>
        </div>

        <div class="thumbnail-card">
          <img :src="person.image" alt="Person Image" />
        </div>
      </div>

      <i class="separator"></i>

      <div class="body-card clear">
        <p>
          Join us for our Live Infinity Session in beautiful New York City.
          This is a 3 day intensive workshop where you'll
          learn how to become a better version of...
        </p>
      </div>

      <div class="bottom-card">
        <i class="separator right"></i>

        <div class="foot-card clear">
          <div class="go-profile" v-if="person.show">
            <router-link :to="person.id | addId ">Ver Perfil</router-link>
          </div>
          <div class="contacts">
            <a v-if="person.mail" :href="person.mail | mailTo" target="_blank" class="contact">
              <font-awesome-icon :icon="['fas', 'envelope']"></font-awesome-icon>
            </a>
            <a v-if="person.linkedin" :href="person.linkedin" target="_blank" class="contact">
              <font-awesome-icon :icon="['fab', 'linkedin-in']"></font-awesome-icon>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'CardEmployee',
  components: {
    FontAwesomeIcon,
  },
  props: {
    person: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  filters: {
    addId(id) {
      return `/about/${id}`;
    },
    mailTo(mail) {
      return `mailto:${mail}`;
    },
  },
};
</script>

<style lang="scss" scoped>
div.employee-card {
  margin: 20px;
  position: relative;
  border-radius: 3px;
  overflow: hidden;
  -webkit-box-shadow: 0 0 2px #666;
  box-shadow: 0 0 2px #666;

  img.image-card {
    width: 100%;
    margin-bottom: -4px;
    transition: all 0.5s;
  }

  div.content-card {
    position: absolute;
    width: calc(100% - 40px);
    top: 0;
    bottom: 0;
    padding: 20px;
    opacity: 0;
    transition: all 0.5s;

    div.head-card {
      width: 100%;
      display: flex;
      transform: translateY(40px);
      transition: all 0.7s;

      div.titles-card {
        width: 70%;
        padding: 20px 0;
        text-align: justify;

        h2 {
          margin: 0 0 10px 0;
          padding: 0;
          font-family: Georgia, "Times New Roman", Times, serif;
          font-weight: normal;
        }

        p {
          margin: 0;
          padding: 0;
          font-family: "Lucida Grande", Tahoma;
          font-size: 0.8em;
          text-align: left;
          text-transform: uppercase;
          letter-spacing: 0.1em;
        }
      }

      div.thumbnail-card {
        width: 30%;
        position: relative;
        overflow: hidden;

        img {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 80%;
          border-radius: 50%;
        }
      }
    }

    i.separator {
      width: 0;
      height: 2px;
      display: block;
      background-color: #fff;
      transition: width 0.6s;

      &.right {
        float: right;
      }
    }

    div.body-card {
      width: 100%;
      margin: 0;
      padding: 20px 0;
      text-align: justify;
      transform: translateY(40px);
      transition: all 0.7s;
      opacity: 0;

      p {
        margin: 0;
        padding: 0;
        font-family: Georgia, "Times New Roman", Times, serif;
        font-weight: normal;
        font-size: 18px;
        line-height: 1.5em;
      }
    }

    div.bottom-card {
      width: calc(100% - 40px);
      position: absolute;
      bottom: 20px;
      left: 20px;

      div.foot-card {
        display: flex;
        width: 100%;
        margin: 0;
        padding: 20px 0;

        div.go-profile {
          width: 70%;
          margin: auto;

          a {
            text-decoration: none;
            font-family: "Lucida Grande", Tahoma;
            margin: auto;
            font-size: 1em;
            font-weight: lighter;
            font-variant: normal;
            text-transform: uppercase;
            letter-spacing: 0.3em;
            color: #fff;
          }
        }

        div.contacts {
          width: 30%;
          transform: translateY(40px);
          transition: all 0.7s;
          opacity: 0;

          a.contact {
            margin: 0 10px;
            text-decoration: none;
            color: #fff;
            font-size: 1.5em;
          }
        }
      }
    }
  }

  &:hover {
    img.image-card {
      -webkit-filter: brightness(30%) grayscale(100%);
      filter: brightness(30%)  grayscale(100%);
    }

    div.content-card {
      opacity: 1;

      i.separator {
        width: 100%;
      }

      div.head-card {
        transform: translateY(0px);
      }

      div.body-card {
        transform: translateY(0px);
        transition-delay: 0.3s;
        opacity: 1;
      }

      div.bottom-card {
        div.foot-card {
          div.contacts {
            transform: translateY(0px);
            transition-delay: 0.6s;
            opacity: 1;
          }
        }
      }
    }
  }
}
</style>
